import { render, staticRenderFns } from "./TransferOfOwnership.vue?vue&type=template&id=08afe346&scoped=true&"
import script from "./TransferOfOwnership.vue?vue&type=script&lang=js&"
export * from "./TransferOfOwnership.vue?vue&type=script&lang=js&"
import style0 from "./TransferOfOwnership.vue?vue&type=style&index=0&id=08afe346&scoped=true&lang=css&"
import style1 from "./TransferOfOwnership.vue?vue&type=style&index=1&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afe346",
  null
  
)

export default component.exports